(ns admin.events.floating
  (:require [kyber.lib.kyber-eql :refer [defmutate]]
            [admin.utils :as au]
            [kyber.events.eql :as eql]
            [kyber.lib.kyber-db :as kyber-db]
            [kyber.events.utils :refer [kyber-event-fx]]
            [kyber.kyber-db.activity-resource :as activity-resource]))

(defmutate create-floating
  {:model-key :questionnaire
   :mutation-symbol 'floating/create
   :event-namespace ::self
   :analytics-key :floating-questionnaires/create-floating
   :update-fn (fn [db _req res]
                (kyber-db/tx-record db {:model :activity} {:activity/floating-questionnaires [{:questionnaire/uuid (:questionnaire/uuid res)}]
                                                           :activity/uuid (:activity/uuid res)}))})

(defmutate update-floating
  {:model-key :questionnaire
   :mutation-symbol 'floating/update
   :event-namespace ::self
   :analytics-key :floating-questionnaire/update-floating})


(defmutate delete-floating
  {:model-key :questionnaire
   :mutation-symbol 'floating/delete
   :event-namespace ::self
   :analytics-key :floating-questionnaires/delete-floating
   :update-fn (fn [db req _res] (-> db
                                    (kyber-db/retract-record {:model :questionnaire} {:questionnaire/uuid (:questionnaire/uuid req)})
                                    (kyber-db/retract-ref
                                     {:model :activity
                                      :refs-key :activity/floating-questionnaires
                                      :ref-ident-key (:questionnaire/uuid req)}
                                     {:activity/uuid (:activity/uuid req)})))})


;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;; Floating questionnaire question-context sorting ;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defn adjust-question-sort-order-success
  [{:keys [db]} [_ {questionnaire-uuid :questionnaire-uuid} {:keys [on-success]} {:floating.question.context/syms [sort]}]]
  (let [floating-questions
        (-> sort
            :questionnaire/questions)]
    (cond-> {:db (kyber-db/tx-record db
                                     {:ident-key questionnaire-uuid
                                      :model :questionnaire
                                      :resort-child-idents true}
                                     {:questionnaire/questions floating-questions})
             :dispatch-n [[:analytics/save-datapoint {:event :floating/adjust-question-sort-order-success
                                                      :event-version 0}]]}
      (fn? on-success)
      (assoc :invoke on-success))))

(kyber-event-fx ::adjust-question-sort-order-success adjust-question-sort-order-success)

(defn adjust-question-sort-order-failure
  [{:keys [db]} [_ _ {:keys [on-failure]} _err]]
  (cond-> {:db db
           :dispatch-n [[:analytics/save-datapoint {:event :floating/adjust-question-sort-order-failure
                                                    :event-version 0}]]}
    (fn? on-failure)
    (assoc :invoke on-failure)))

(kyber-event-fx ::adjust-question-sort-order-failure adjust-question-sort-order-failure)

(defn adjust-question-sort-order
  [{:keys [db]} [_ {:keys [activity-uuid questionnaire-uuid question-start-idx question-end-idx]} options]]
  (let [{floating-questions :questionnaire/questions}
        (kyber-db/get-record db :questionnaire questionnaire-uuid)

        sorted-questions
        (->> floating-questions
             (au/reorder-coll question-start-idx question-end-idx)
             (mapv #(:question.context/uuid %)))]
    {:db db
     :dispatch-n [[:analytics/save-datapoint {:event :floating/adjust-question-sort-order
                                              :event-version 0}]]
     :request
     (eql/request
      db
      {:name ::adjust-question-sort-order
       :params `[{(floating.question.context/sort
                   {:activity/uuid ~activity-uuid
                    :questionnaire/uuid ~questionnaire-uuid
                    :floating/question-context-sort-order ~sorted-questions})
                  [{:questionnaire/questions [:question.context/uuid]}]}]
       :on-success [::adjust-question-sort-order-success {:activity-uuid activity-uuid :questionnaire-uuid questionnaire-uuid} options]
       :on-failure [::adjust-question-sort-order-failure {:activity-uuid activity-uuid :questionniare-uuid questionnaire-uuid} options]})}))

(kyber-event-fx ::adjust-question-sort-order adjust-question-sort-order)

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;; Floating question-context CRUD mutations ;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defmutate create-floating-question-context
  {:model-key :question-context
   :mutation-symbol 'floating.question.context/create
   :event-namespace ::self
   :analytics-key :floating/create-question-context
   :update-fn (fn [db {questionnaire-uuid :questionnaire/uuid question-uuid :question/uuid} res]
                (kyber-db/tx-record db
                                    {:ident-key questionnaire-uuid
                                     :model :questionnaire}
                                    {:questionnaire/questions [(assoc res :question.context/question
                                                                      {:question/uuid question-uuid})]}))})

(defmutate update-floating-question-context
  {:model-key :question-context
   :mutation-symbol 'floating.question.context/update
   :event-namespace ::self
   :analytics-key :floating/update-question-context})

(defmutate delete-floating-question-context
  {:model-key :question-context
   :mutation-symbol 'floating.question.context/delete
   :event-namespace ::self
   :analytics-key :floating/delete-question-context
   :update-fn (fn [db req _res]
                (let [question-context-uuid
                      (:question.context/uuid req)

                      questionnaire-uuid
                      (:questionnaire/uuid req)]
                  (-> db
                      (kyber-db/retract-record {:model :question-context} {:question.context/uuid question-context-uuid})
                      (kyber-db/retract-ref
                       {:model :questionnaire
                        :refs-key :questionnaire/questions
                        :ref-ident-key question-context-uuid}
                       {:questionnaire/uuid questionnaire-uuid}))))})


;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; question.context resource mutations ;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defmutate add-floating-question-context-resource
  {:model-key :question-context
   :mutation-symbol 'floating.question.context.resource/add
   :event-namespace ::self
   :analytics-key :floating/add-question-context-resource
   :update-fn
   (fn [db request _response-body]
     (kyber-db/tx-record
      db
      {:model :question-context}
      {:question.context/uuid (:question.context/uuid request)
       :question.context/resources [(select-keys request [:activity/uuid :resource/uuid])]}))})

(defmutate remove-floating-question-context-resource
  {:model-key :question-context
   :mutation-symbol 'floating.question.context.resource/remove
   :event-namespace ::self
   :analytics-key :floating/remove-question-context-resource
   :update-fn
   (fn [db request _response-body]
     (kyber-db/retract-ref
      db
      {:model :question-context
       :refs-key :question.context/resources
       :ref-ident-key (activity-resource/->ident-key {:resource/uuid (:resource/uuid request)
                                                      :activity/uuid (:activity/uuid request)})}
      {:question.context/uuid (:question.context/uuid request)}))})
